<template>
	<nuxt-link :to="url">
		<b-button variant="primary" :size="size" class="d-flex align-items-center">
			<span style="white-space: nowrap;">
				<slot />
			</span>
			<span class="d-flex ml-1 small icon-chevron-thin-right" />
		</b-button>
	</nuxt-link>
</template>
<script>
import ArrowNext from '~/static/svg/arrow-next.vue';

export default {
	name: 'ArrowButton',
	components: { ArrowNext },
	props: {
		url: {
			type: [String, Object],
			default: '',
		},
		size: {
			type: String,
			default: 'lg',
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.arrow-button {
	height: 4rem;
	padding: 0 1.5rem;
	font-size: 1.2rem;
	border-radius: 2.5rem;

	span {
		white-space: nowrap;
	}

	svg {
		width: 1.5rem;
		height: auto;
	}

	@include media-breakpoint-down(md) {
		height: 2rem;
		font-size: 0.7rem;
		padding: 0 1rem;

		span {
			display: none;
		}

		svg {
			width: 0.7rem;
		}
	}
}
</style>
